//https://sap-ist-public.delego-cloud.com/DelegoRP/sdk/doc/enums/rapidpaysdk.errorcause.html
export enum DelegoRapidPayErrorCause {
  PermissionDenied,
  TokenizeError,
  ThirdPartyAPMError,
  OtherError,
}

//https://sap-ist-public.delego-cloud.com/DelegoRP/sdk/doc/enums/rapidpaysdk.instalmenttype.html
export enum DelegoRapidPayInstalmentType {
  DEFERRED = 'D',
  INSTALMENT = 'I',
  SPECIAL = 'B',
  SUBSCRIPTION = 'S',
}

//https://sap-ist-public.delego-cloud.com/DelegoRP/sdk/doc/enums/rapidpaysdk.show.html
export enum DelegoRapidPayShow {
  Checkout,
  ExpressCheckout,
  PaymentSummary,
}

//https://sap-ist-public.delego-cloud.com/DelegoRP/sdk/doc/enums/rapidpaysdk.threedsecurestatus.html
export enum DelegoRapidPayThreeDSecureStatus {
  Failure = 'N',
  Rejected = 'R',
  Success = 'Y',
  SuccessfulAttempts = 'A',
  UnableToComplete = 'U',
}

//https://sap-ist-public.delego-cloud.com/DelegoRP/sdk/doc/enums/rapidpaysdk.threedsecurestatusreason.html
export enum DelegoRapidPayThreeDSecureStatusReason {
  ACS_TECHNICAL_ISSUE = '22',
  AUTHENTICATION_ATTEMPTED_BUT_NOT_PERFORMED_BY_CARDHOLDER = '26',
  CARDHOLDER_NOT_ENROLLED_IN_SERVICE = '13',
  CARD_AUTHENTICATION_FAILED = '01',
  CARD_AUTHENTICATION_FAILED_AMEX_PLASTICLESS = '80',
  DECOUPLED_AUTHENTICATION_REQUIRED_BY_ACS = '23',
  DECOUPLED_AUTHENTICATION_WAS_PROVIDED_INSUFFICIENT_TIME_ACS_WILL_NOT_ATTEMPT = '25',
  DS_SERVER_INVALID_RESPONSE = 'DELEGO.3DS_SERVER_INVALID_RESPONSE',
  EXCEEDS_ACS_MAX_CHALLENGES = '19',
  EXCEEDS_AUTHENTICATION_FREQUENCY_LIMIT = '04',
  EXPIRED_CARD = '05',
  HIGH_CONFIDENCE = '17',
  INVALID_CARD_NUMBER = '06',
  INVALID_DATA = 'DELEGO.INVALID_DATA',
  INVALID_TRANSACTION = '07',
  ISSUER_NOT_ENROLLED_IN_SERVICE = 'DELEGO.ISSUER_NOT_ENROLLED_IN_SERVICE',
  LOW_CONFIDENCE = '15',
  MEDIUM_CONFIDENCE = '16',
  NON_PAYMENT_UNSUPPORTED = '20',
  NO_CARD_RECORD = '08',
  REQUESTED_DECOUPLED_MAX_EXPIRY_TIME_EXCEEDED = '24',
  SECURITY_FAILURE = '09',
  STOLEN_CARD = '10',
  SUSPECTED_FRAUD = '11',
  THREE_DS_ONE_BYPASSED = 'DELEGO.3DS_1.0_BYPASSED',
  THREE_DS_SERVICE_NOT_ENABLED = 'DELEGO.3DS_NOT_ENABLED',
  THREE_RI_NOT_SUPPORTED = '21',
  TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER = '12',
  TRANSACTION_TIMED_OUT_AT_ACS = '14',
  UNKNOWN_DEVICE = '02',
  UNSUPPORTED_DEVICE = '03',
  VERY_HIGH_CONFIDENCE = '18',
}

// https://sap-ist-public.delego-cloud.com/DelegoRP/sdk/doc/enums/rapidpaysdkv2.deliverytimeframe.html
export enum DelegoRapidPayDeliveryTimeframe {
  ELECTRONIC_DELIVERY = '01',
  SAME_DAY_SHIPPING = '02',
  OVERNIGHT_SHIPPING = '03',
  TWO_DAY_OR_MORE_SHIPPING = '04',
}

//https://sap-ist-public.delego-cloud.com/DelegoRP/sdk/doc/enums/rapidpaysdkv2.shipindicator.html
export enum DelegoRapidPayShipIndicator {
  SHIP_TO_CARDHOLDER_BILLING_ADDRESS = '01',
  SHIP_TO_ANOTHER_VERIFIED_ADDRESS = '02',
  SHIP_TO_ADDRESS_DIFFERENT_FROM_BILLING = '03',
  SHIP_TO_STORE = '04',
  DIGITAL_GOODS = '05',
  TRAVEL_AND_EVENT_TICKETS_NOT_SHIPPED = '06',
  OTHER = '07',
}
